import Vue from "vue";
import Router from "vue-router";
import { i18n } from "@/main";

import layouts from "../layout";

import store from "../store";
Vue.use(Router);

const router = new Router({
  mode: "history",
  //base: '/sub-path/',
  routes: [
    {
      path: "/my-presence",
      name: "my-presence",
      component: () => import("@/views/pages/MyPresence.vue"),
      meta: {
        title: "my_presence",
        auth: true,
        layout: layouts.navTop,
        searchable: true,
        tags: ["pages"],
      },
      beforeEnter: (to, from, next) => {
        const roleId = store.getters.user.roleId;
        if (roleId === 2) {
          next("/unauthorized");
        } else {
          next();
        }
      },
    },
    {
      path: "/my-calendar",
      name: "my-calendar",
      component: () => import("@/views/pages/MyCalendar.vue"),
      meta: {
        title: "my_calendar",
        auth: true,
        layout: layouts.navTop,
        searchable: true,
        tags: ["pages"],
      },
      beforeEnter: (to, from, next) => {
        const roleId = store.getters.user.roleId;
        if (roleId === 2) {
          next("/unauthorized");
        } else {
          next();
        }
      },
    },
    {
      path: "/calendar",
      name: "calendar",
      component: () => import("@/views/pages/TeamLeaderCalendar.vue"),
      meta: {
        title: "calendar",
        auth: true,
        layout: layouts.navTop,
        searchable: true,
        tags: ["pages"],
      },
      beforeEnter: (to, from, next) => {
        const roleId = store.getters.user.roleId;
        if (roleId === 5) {
          next("/unauthorized");
        } else {
          next();
        }
      },
    },
    {
      path: "/my-profile",
      name: "my-profile",
      component: () => import("@/views/pages/MyProfile.vue"),
      meta: {
        title: "my_profile",
        auth: true,
        layout: layouts.navTop,
        searchable: true,
        tags: ["pages"],
      },
    },
    {
      path: "/dashboard",
      name: "dashboard",
      component: () => import("@/views/pages/Dashboard.vue"),
      meta: {
        title: "dashboard",
        auth: true,
        layout: layouts.navTop,
        searchable: true,
        tags: ["pages"],
      },
      beforeEnter: (to, from, next) => {
        const roleId = store.getters.user.roleId;
        if (roleId === 5) {
          next("/unauthorized");
        } else {
          next();
        }
      },
    },

    {
      path: "/privacy-policy",
      name: "privacy-policy",
      component: () => import("@/views/pages/PrivacyPolicy.vue"),
      meta: {
        title: "privacy_policy",
        auth: true,
        layout: {
          navPos: "top",
          toolbar: "bottom",
          boxed: false,
          roundedCorners: false,
          footer: "below",
        },
      },
    },
    {
      path: "/cookie-policy",
      name: "cookie-policy",
      component: () => import("@/views/pages/CookiePolicy.vue"),
      meta: {
        title: "cookie_policy",
        auth: true,
        layout: {
          navPos: "top",
          toolbar: "bottom",
          boxed: false,
          roundedCorners: false,
          footer: "below",
        },
      },
    },
    {
      path: "/presence",
      name: "presence",
      component: () => import("@/views/pages/TeamLeadPresence.vue"),
      meta: {
        title: "presence",
        auth: true,
        layout: layouts.navTop,
        searchable: true,
        tags: ["pages"],
      },
      beforeEnter: (to, from, next) => {
        const roleId = store.getters.user.roleId;
        if (roleId === 5) {
          next("/unauthorized");
        } else {
          next();
        }
      },
    },
    {
      path: "/shift-reports",
      name: "shift-reports",
      component: () => import("@/views/pages/ShiftReports.vue"),
      meta: {
        title: "shift_reports",
        auth: true,
        layout: {
          navPos: "top",
          toolbar: "bottom",
          boxed: false,
          roundedCorners: false,
          footer: "below",
        },
      },
      beforeEnter: (to, from, next) => {
        const roleId = store.getters.user.roleId;
        if (roleId === 5) {
          next("/unauthorized");
        } else {
          next();
        }
      },
    },
    {
      path: "/calendar-reports",
      name: "calendar-reports",
      component: () => import("@/views/pages/CalendarReports.vue"),
      meta: {
        title: "calendar_reports",
        auth: true,
        layout: {
          navPos: "top",
          toolbar: "bottom",
          boxed: false,
          roundedCorners: false,
          footer: "below",
        },
      },
      beforeEnter: (to, from, next) => {
        const roleId = store.getters.user.roleId;
        if (roleId === 5 || roleId === 4) {
          next("/unauthorized");
        } else {
          next();
        }
      },
    },
    {
      path: "/presence-reports",
      name: "presence-reports",
      component: () => import("@/views/pages/PresenceReports.vue"),
      meta: {
        title: "presence_reports",
        auth: true,
        layout: {
          navPos: "top",
          toolbar: "bottom",
          boxed: false,
          roundedCorners: false,
          footer: "below",
        },
      },
      beforeEnter: (to, from, next) => {
        const roleId = store.getters.user.roleId;
        if (roleId === 5 || roleId === 4) {
          next("/unauthorized");
        } else {
          next();
        }
      },
    },
    {
      path: "/non-rounded-presence-reports",
      name: "non-rounded-presence-reports",
      component: () => import("@/views/pages/NonRoundedPresenceReports.vue"),
      meta: {
        title: "non_rounded_presence_reports",
        auth: true,
        layout: {
          navPos: "top",
          toolbar: "bottom",
          boxed: false,
          roundedCorners: false,
          footer: "below",
        },
      },
      beforeEnter: (to, from, next) => {
        const roleId = store.getters.user.roleId;
        const companyId = store.getters.user.companyId;

        if (
          roleId === 5 ||
          roleId === 4 ||
          roleId === 6 ||
          roleId === 7 ||
          roleId === 3 ||
          companyId !== 1
        ) {
          next("/unauthorized");
        } else {
          next();
        }
      },
    },
    {
      path: "/sentice-reports",
      name: "sentice-reports",
      component: () => import("@/views/pages/SenticeReports.vue"),
      meta: {
        title: "sentice_report",
        auth: true,
        layout: {
          navPos: "top",
          toolbar: "bottom",
          boxed: false,
          roundedCorners: false,
          footer: "below",
        },
      },
      beforeEnter: (to, from, next) => {
        const roleId = store.getters.user.roleId;
        const companyId = store.getters.user.companyId;

        if (
          roleId === 5 ||
          roleId === 4 ||
          roleId === 6 ||
          roleId === 7 ||
          roleId === 2 ||
          roleId === 1 ||
          companyId !== 1
        ) {
          next("/unauthorized");
        } else {
          next();
        }
      },
    },
    {
      path: "/administrator-reports",
      name: "administrative-reports",
      component: () => import("@/views/pages/AdministrativeReports.vue"),
      meta: {
        title: "administrators_report",
        auth: true,
        layout: {
          navPos: "top",
          toolbar: "bottom",
          boxed: false,
          roundedCorners: false,
          footer: "below",
        },
      },
      beforeEnter: (to, from, next) => {
        const roleId = store.getters.user.roleId;
        if (roleId === 5 || roleId === 4 || roleId === 6) {
          next("/unauthorized");
        } else {
          next();
        }
      },
    },
    {
      path: "/users",
      name: "users",
      component: () => import("@/views/pages/Users.vue"),
      meta: {
        title: "users",
        auth: true,
        layout: {
          navPos: "top",
          toolbar: "bottom",
          boxed: false,
          roundedCorners: false,
          footer: "below",
        },
      },
      beforeEnter: (to, from, next) => {
        const roleId = store.getters.user.roleId;
        if (roleId === 5 || roleId === 4 || roleId === 6 || roleId === 2) {
          next("/unauthorized");
        } else {
          next();
        }
      },
    },
    {
      path: "/add-user",
      name: "addUser",
      component: () => import("@/components/settings/users/AddUser.vue"),
      meta: {
        title: "add_user",
        auth: true,
        layout: {
          navPos: "top",
          toolbar: "bottom",
          boxed: false,
          roundedCorners: false,
          footer: "below",
        },
      },
      beforeEnter: (to, from, next) => {
        const roleId = store.getters.user.roleId;
        if (roleId === 5 || roleId === 4 || roleId === 6 || roleId === 2) {
          next("/unauthorized");
        } else {
          next();
        }
      },
    },
    {
      path: "/edit-user",
      name: "editUser",
      component: () => import("@/components/settings/users/EditUser.vue"),
      meta: {
        title: "edit_user",
        auth: true,
        props: true,
        layout: {
          navPos: "top",
          toolbar: "bottom",
          boxed: false,
          roundedCorners: false,
          footer: "below",
        },
      },
      beforeEnter: (to, from, next) => {
        const roleId = store.getters.user.roleId;
        if (roleId === 5 || roleId === 4 || roleId === 6 || roleId === 2) {
          next("/unauthorized");
        } else {
          next();
        }
      },
    },
    {
      path: "/work-rules",
      name: "workRules",
      component: () => import("@/components/settings/users/WorkRules.vue"),
      meta: {
        title: "work_rules",
        auth: true,
        props: true,
        layout: {
          navPos: "top",
          toolbar: "bottom",
          boxed: false,
          roundedCorners: false,
          footer: "below",
        },
      },
      beforeEnter: (to, from, next) => {
        const roleId = store.getters.user.roleId;
        if (roleId === 5 || roleId === 4 || roleId === 6 || roleId === 2) {
          next("/unauthorized");
        } else {
          next();
        }
      },
    },
    {
      path: "/departments",
      name: "departments",
      component: () => import("@/views/pages/Departments.vue"),
      meta: {
        title: "departments",
        auth: true,
        layout: {
          navPos: "top",
          toolbar: "bottom",
          boxed: false,
          roundedCorners: false,
          footer: "below",
        },
      },
      beforeEnter: (to, from, next) => {
        const roleId = store.getters.user.roleId;
        if (roleId === 5 || roleId === 4 || roleId === 6 || roleId === 2) {
          next("/unauthorized");
        } else {
          next();
        }
      },
    },
    {
      path: "/teams",
      name: "teams",
      component: () => import("@/views/pages/Teams.vue"),
      meta: {
        title: "teams",
        auth: true,
        layout: {
          navPos: "top",
          toolbar: "bottom",
          boxed: false,
          roundedCorners: false,
          footer: "below",
        },
      },
      beforeEnter: (to, from, next) => {
        const roleId = store.getters.user.roleId;
        if (roleId === 5 || roleId === 4 || roleId === 2) {
          next("/unauthorized");
        } else {
          next();
        }
      },
    },
    {
      path: "/nationality-religion-view",
      name: "NationalityAndReligion",
      component: () => import("@/views/pages/NationalityAndReligion.vue"),
      meta: {
        title: "nationality_religion",
        auth: true,
        layout: {
          navPos: "top",
          toolbar: "bottom",
          boxed: false,
          roundedCorners: false,
          footer: "below",
        },
      },
      beforeEnter: (to, from, next) => {
        const roleId = store.getters.user.roleId;
        if (roleId === 5 || roleId === 4 || roleId === 6 || roleId === 2) {
          next("/unauthorized");
        } else {
          next();
        }
      },
    },
    {
      path: "/company-details",
      name: "CompanyDetails",
      component: () => import("@/views/pages/Details.vue"),
      meta: {
        title: "company_details",
        auth: true,
        layout: {
          navPos: "top",
          toolbar: "bottom",
          boxed: false,
          roundedCorners: false,
          footer: "below",
        },
      },
      beforeEnter: (to, from, next) => {
        const roleId = store.getters.user.roleId;
        if (
          roleId === 5 ||
          roleId === 4 ||
          roleId === 6 ||
          roleId === 2 ||
          roleId === 3 ||
          roleId === 7
        ) {
          next("/unauthorized");
        } else {
          next();
        }
      },
    },
    {
      path: "/settings",
      name: "Settings",
      component: () => import("@/views/pages/Settings.vue"),
      meta: {
        title: "settings",
        auth: true,
        layout: {
          navPos: "top",
          toolbar: "bottom",
          boxed: false,
          roundedCorners: false,
          footer: "below",
        },
      },
      beforeEnter: (to, from, next) => {
        const roleId = store.getters.user.roleId;
        if (
          roleId === 5 ||
          roleId === 4 ||
          roleId === 6 ||
          roleId === 2 ||
          roleId === 3
        ) {
          next("/unauthorized");
        } else {
          next();
        }
      },
    },
    {
      path: "/gates",
      name: "Gates",
      component: () => import("@/views/pages/Gates.vue"),
      meta: {
        title: "gates",
        auth: true,
        layout: {
          navPos: "top",
          toolbar: "bottom",
          boxed: false,
          roundedCorners: false,
          footer: "below",
        },
      },
      beforeEnter: (to, from, next) => {
        const roleId = store.getters.user.roleId;
        if (
          roleId === 5 ||
          roleId === 4 ||
          roleId === 6 ||
          roleId === 2 ||
          roleId === 3
        ) {
          next("/unauthorized");
        } else {
          next();
        }
      },
    },
    {
      path: "/document-templates",
      name: "DocumentTemplates",
      component: () => import("@/views/pages/DocumentTemplates.vue"),
      meta: {
        title: "document_templates",
        auth: true,
        layout: {
          navPos: "top",
          toolbar: "bottom",
          boxed: false,
          roundedCorners: false,
          footer: "below",
        },
      },
      beforeEnter: (to, from, next) => {
        const roleId = store.getters.user.roleId;
        if (roleId === 5 || roleId === 4 || roleId === 6 || roleId === 2) {
          next("/unauthorized");
        } else {
          next();
        }
      },
    },
    {
      path: "/holiday",
      name: "Holiday",
      component: () => import("@/views/pages/Holiday.vue"),
      meta: {
        title: "holiday",
        auth: true,
        layout: {
          navPos: "top",
          toolbar: "bottom",
          boxed: false,
          roundedCorners: false,
          footer: "below",
        },
      },
      beforeEnter: (to, from, next) => {
        const roleId = store.getters.user.roleId;
        if (roleId === 5 || roleId === 4 || roleId === 6 || roleId === 2) {
          next("/unauthorized");
        } else {
          next();
        }
      },
    },
    {
      path: "/",
      name: "login",
      component: () => import("@/views/pages/authentication/Login.vue"),
      meta: {
        title: "loginPage",
        layout: layouts.contenOnly,
      },
    },
    {
      path: "/register",
      name: "register_page",
      component: () => import("@/views/pages/authentication/RegisterPage.vue"),
      meta: {
        title: "register_company",
        layout: layouts.contenOnly,
      },
    },
    {
      path: "/email/verify/:id/:hash",
      name: "verify_email",
      component: () => import("@/views/pages/authentication/VerifyPage.vue"),
      meta: {
        title: "email_verification",
        layout: layouts.contenOnly,
      },
    },
    //{
    //  path: "/logout",
    //  beforeEnter(to, from, next) {
    //    auth.logout();
    //    next({ path: "/login" });
    //  },
    //},
    {
      path: "*",
      name: "not-found",
      component: () => import("@/views/pages/NotFound.vue"),
      meta: {
        title: "not_found",
        layout: layouts.contenOnly,
      },
    },
  ],
});

const l = {
  contenOnly() {
    store.commit("setLayout", layouts.contenOnly);
  },
  navLeft() {
    store.commit("setLayout", layouts.navLeft);
  },
  navRight() {
    store.commit("setLayout", layouts.navRight);
  },
  navTop() {
    store.commit("setLayout", layouts.navTop);
  },
  navBottom() {
    store.commit("setLayout", layouts.navBottom);
  },
  set(layout) {
    store.commit("setLayout", layout);
  },
};

//insert here login logic
const auth = {
  loggedIn() {
    return store.getters.isLogged;
  },
  logout() {
    store.commit("setLogout");
  },
};

router.beforeEach((to, from, next) => {
  // if(to.name == from.name){
  //  console.log("Not redirecting")
  //   return false
  // }
  //console.log("ROUTER\nfrom: ", from.name, "\nto: ", to.name);

  const termsAndConditionsAccepted = store.getters.termsAndConditionsAccepted;
  //console.log("termsAndConditionsAccepted:", termsAndConditionsAccepted);

  let authrequired = false;
  if (to && to.meta && to.meta.auth) authrequired = true;

  //console.log('authrequired', authrequired, to.name)

  if (authrequired) {
    if (auth.loggedIn()) {
      if (
        !["privacy-policy", "cookie-policy"].includes(to.name) &&
        !termsAndConditionsAccepted
      ) {
        next("/privacy-policy");
        return false;
      } else if (to.name === "login" && !to.query.token) {
        next("/my-presence");
        return false;
      } else {
        next();
      }
    }

    //// if authrequired but not logged in
    //else if (to.name !== "login") {
    //    next({ name: 'login' });
    //    return false;
    //  }

    // if authrequired and we go to /
    else {
      next({ name: "login" });
    }
  }
  // if not authrequired
  else {
    if (auth.loggedIn() && to.name === "login" && !to.query.token) {
      termsAndConditionsAccepted
        ? next("/my-presence")
        : next("/privacy-policy");
      return false;
    } else {
      next();
    }
  }

  if (to && to.meta && to.meta.layout) {
    l.set(to.meta.layout);
  }
});

router.afterEach((to, from) => {
  // Scroll to the top of the .global-scrollbar element after a delay
  setTimeout(() => {
    const globalScrollbar = document.querySelector(".global-scrollbar");
    if (globalScrollbar) {
      globalScrollbar.scrollTop = 0;
      //console.log('Scroll to top');
    }
  }, 500);

  // Translate the title using vue-i18n
  const translatedTitle = i18n.t(to.meta.title);

  // Set the document title to the translated title
  if (to.meta.title != "not_found") {
    document.title = "AbSent | " + translatedTitle;
  } else {
    document.title = "404 | " + translatedTitle;
  }
});

export default router;
